import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'marv-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
})
export class MarvItemComponent  implements OnInit {

    @Input({alias : 'fullHeight', required : false}) fullHeight: boolean = false;  

    constructor() { }

    ngOnInit() {}

}
